<template>
	<div class="container">
		<div class="image-container">
			<img :src="image" alt="">
		</div>
		<div class="button-container">
			<button
				type="button"
				class="button"
				@click="remove"
			></button>
		</div>
	</div>
</template>
<script>

function remove() {
	this.$emit('remove-button');
}

export default {
	name: 'mini-image-component',
	methods: {
		remove,
	},
	props: {
		image: {
			default: '',
			type: String,
		},
	},
};
</script>
<style lang="scss" scoped>
.container {
	height: 52px;
	position: relative;
	width: 83px;
}

.image-container {
	height: inherit;
	width: inherit;

	img {
		object-fit: cover;
		width: inherit;
	}
}

.button-container {
	align-items: center;
	display: flex;
	height: inherit;
	justify-content: center;
	position: absolute;
	left: 85%;
	top: 0;

	.button {
		background-color: white;
		border-radius: 50%;
		box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
		height: 35px;
		transform: rotate(45deg);
		width: 35px;

		&::before {
			content: '+';
			font-size: 30px;
		}
	}
}
</style>




// WEBPACK FOOTER //
// src/components/commons/mini-image-component.vue